import { useTranslation } from 'react-i18next'
import { Monitor, Moon, Sun } from 'lucide-react'
import { useTheme, type ThemePreference } from '@/app/theme'
import { cn } from '@/lib/utils'

const OPTIONS: Array<{ value: ThemePreference; icon: typeof Sun; labelKey: string }> = [
  { value: 'light', icon: Sun, labelKey: 'theme.light' },
  { value: 'dark', icon: Moon, labelKey: 'theme.dark' },
  { value: 'system', icon: Monitor, labelKey: 'theme.system' },
]

export function ThemeToggle({ className }: { className?: string }) {
  const { t } = useTranslation()
  const { preference, setPreference } = useTheme()

  return (
    <div
      role="group"
      aria-label={t('theme.toggle')}
      className={cn('inline-flex rounded-sm border border-border-strong p-[2px]', className)}
    >
      {OPTIONS.map(({ value, icon: Icon, labelKey }) => (
        <button
          key={value}
          type="button"
          aria-pressed={preference === value}
          title={t(labelKey)}
          onClick={() => setPreference(value)}
          className={cn(
            'rounded-[4px] p-1.5 transition-colors',
            preference === value
              ? 'bg-itpu-teal text-white'
              : 'text-text-muted hover:bg-surface-tint hover:text-text',
          )}
        >
          <Icon aria-hidden className="size-4" strokeWidth={1.75} />
          <span className="sr-only">{t(labelKey)}</span>
        </button>
      ))}
    </div>
  )
}
